import type { LinearFn2d, Point2d } from "."
import { findClosestPointOnLine, findDistanceBetweenPoints } from "."

export const findDistanceBetweenPointAndLine = (
  point: Point2d,
  line: LinearFn2d,
): number => {
  const closestPoint = findClosestPointOnLine(point, line)

  return findDistanceBetweenPoints(point, closestPoint)
}
